import _ from 'lodash';
import config from 'src/shared/config';
import axios from 'src/shared/utils/axios';
import DummyApi from '../dummyApi';
import { times } from '../api';
const INFRA_API_ENABLED = config.servers.infra.enabled;
const INFRA_API_URL = config.servers.infra.url;
interface Dept {
  code: string;
  name: string;
}
interface AccessIp {
  fromIp: string;
  toIp: string;
  updatedTime: number;
}
export interface AdminDto {
  user: {
    id: string;
    name: string;
    position: string;
    role: string;
    email: string;
    phoneNumber: string;
  };
  type: {
    code: string;
    name: string;
    desc: string;
    menus: string[];
  };
  depts: Dept[];
  createdTime: number;
  restrictIp: boolean;
  accessIps: AccessIp[];
  startTime: number;
  endTime: number;
}
export enum AdminApiError {
  NOT_FOUND_ADMINASSIGNMENT = 'NOT_FOUND_ADMINASSIGNMENT',
}
interface AdminApi {
  assignments(adminId: string): Promise<AdminDto>;
  assignmentsWithToken(token: string, adminId: string): Promise<AdminDto>;
  list(): Promise<AdminDto[]>;
}
class AdminServerApi implements AdminApi {
  async assignments(adminId: string): Promise<AdminDto> {
    const resp = await axios.get(`${INFRA_API_URL}/api/admin/assignments/${adminId}`);
    return resp.data;
  }
  async assignmentsWithToken(token: string, adminId: string): Promise<AdminDto> {
    const resp = await axios.get(`${INFRA_API_URL}/api/admin/assignments/${adminId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return resp.data;
  }
  async list(): Promise<AdminDto[]> {
    const resp = await axios.get(`${INFRA_API_URL}/api/admin/assignments`);
    return resp.data;
  }
}
const adminApi = new AdminServerApi();
export default adminApi;
